export default {
  // ViewedVenue: 'Viewed Venue', //handled by our widgets
  ViewedEvent: 'Viewed Event',

  /* Account */
  LoggedIn: 'Logged In',
  LoggedOut: 'Logged Out',
  ForgotPassword: 'Forgot Password',
  SignedUp: 'Signed Up',
  AddedCreditCard: 'Added Credit Card',

  /* Review */
  SubmittedReview: 'Submitted Review',

  /* Rewards */
  RedeemedPromoCode: 'Redeemed Promo Code',

  /* Support */
  ContactedConcierge: 'Contacted Concierge',

  /* Join Order */
  EnteredJoinCode: 'Entered Join Code',
  JoinedOrder: 'Joined Order',

  /* Push */
  RequestedSMSDownloadLink: 'Requested SMS Download Link',

  /* Favorite */
  FavoritedVenue: 'Favorited Venue',
  FavoritedEvent: 'Favorited Event',
  UnfavoritedVenue: 'Unfavorited Venue',
  UnfavoritedEvent: 'Unfavorited Event',

  /* Inventory Search */
  SearchedInventory: 'Searched Inventory',

  /* Search */
  SearchResultSelected: 'SearchResultSelected',

  /* Order */
  StartedOrder: 'Started Order',
  // AddedProduct: 'Added Product', //handled by our widgets
  StartedCheckout: 'Started Checkout',
  CompletedOrder: 'Completed Order',
  BookingCompleted: 'Booking Completed',
  OrderCompleted: 'Order Completed', //TODO: need to add ios and android events for this

  /* Curated Lists */
  FollowedCuratedList: 'Followed Curated List',
  UnfollowedCuratedList: 'Un-followed Curated List',

  /* Membership */
  TappedFeaturedBanner: 'Tapped Featured Banner',
  ClickedHomepageMembershipAd: 'Clicked Homepage Membership Ad',
  CompletedMembershipOrder: 'Completed Membership Order',
  FilteredMembershipPerks: 'Filtered Membership Perks'
};



// WEBPACK FOOTER //
// ./src/constants/segmentEvents.js